import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import { ChangeEventHandler, Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import IResponse from '../../interfaces/response';
import CarType from '../../interfaces/car';
import { useDebounce } from 'use-debounce';
export default function ChassisSearch() {
	const { setCars, page, setPage, setLoading, setTotalPage } = useOutletContext<{
		setCars: Dispatch<SetStateAction<CarType[]>>,
		page: number,
		setPage: Dispatch<SetStateAction<number>>,
		setLoading: Dispatch<SetStateAction<boolean>>,
		setTotalPage: Dispatch<SetStateAction<number>>,
	}>();
	const [searchTerm, setSearchTerm] = useState('');
	const [search] = useDebounce(searchTerm, 700);

	useEffect(() => {
		setLoading(true);
		axios<IResponse<CarType[]>>({
			url: '/car/chassis',
			params: {
				page,
				chassis: search,
			}
		}).then(res => {
			if (res.data.success) {
				setCars(res.data.data)
				setTotalPage(res.data.pagination?.totalPages ?? 0)
			}
		}).finally(() => {
			setLoading(false);
		})

	}, [search, page])

	const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
		setSearchTerm(e.target.value)
		setPage(1);
	}
	return (
		<div className='relative w-full mb-9'>
			<SearchIcon className='absolute start-2.5 center' />
			<input onChange={handleChange} value={searchTerm} className="w-full ps-11 p-3 bg-primary-selected rounded border border-transparent focus:outline-none focus:bg-secondary-hover focus:ring-2 focus:ring-secondary-outborder focus:border-transparent" />
		</div>
	)
}
